import { getStyle, resolveText } from "./studioModel";

export const EXPORT_PRESETS = [
  ["all", "Full menu"],
  ["dinner", "Dinner menu"],
  ["lunch", "Lunch menu"],
  ["wine", "Beer & wine"],
  ["today", "Changed today"],
];
// A page counts as changed today when its design was edited today, or when
// CMS text it prints was updated today. The two dates stay separate: CMS
// freshness is read from the CMS, never written into the design.
export function contentChangedToday(page, content = {}, now = new Date()) {
  return page.elements.some((n) => {
    const m = /^(item|section):([^:]+):/.exec(n.binding || "");
    const stamp = m && content[`updated:${m[1]}:${m[2]}`];
    return !!stamp && new Date(stamp).toDateString() === now.toDateString();
  });
}
export function changedToday(page, now = new Date(), content) {
  if (content && contentChangedToday(page, content, now)) return true;
  if (!page.modifiedAt) return false;
  return new Date(page.modifiedAt).toDateString() === now.toDateString();
}
export function exportPages(doc, preset, now = new Date(), content) {
  return doc.pages.filter((p) => {
    if (preset === "all") return true;
    if (preset === "today") return changedToday(p, now, content);
    const menu = p.sourceMenu || doc.menuKey;
    return menu === preset || (preset === "dinner" && menu === "cover");
  });
}
function pageSignature(doc, page, content) {
  const { modifiedAt, ...data } = page;
  return JSON.stringify({ ...data, elements: page.elements.map((node) => ({
    ...node,
    resolvedStyle: getStyle(doc, node),
    resolvedText: node.type === "text" ? resolveText(node, content) : undefined,
  })) });
}
// Timestamp only actual page changes, including shared styles and linked CMS copy.
export function stampPageChanges(before, after, beforeContent = {}, afterContent = beforeContent, now = new Date()) {
  const byId = new Map(before.pages.map((p) => [p.id, p]));
  return { ...after, pages: after.pages.map((p) => {
    const old = byId.get(p.id);
    const changed = !old || pageSignature(before, old, beforeContent) !== pageSignature(after, p, afterContent);
    return { ...p, modifiedAt: changed ? now.toISOString() : old.modifiedAt };
  }) };
}

// Commit-time stamping from the operations themselves: only pages an edit
// touched are compared. Document-wide style changes compare every page.
export function stampTouchedPages(before, after, pageIds, content = {}, now = new Date()) {
  if (!pageIds.length) return after;
  const touched = new Set(pageIds);
  const byId = new Map(before.pages.map((p) => [p.id, p]));
  let changed = false;
  const pages = after.pages.map((p) => {
    if (!touched.has(p.id)) return p;
    const old = byId.get(p.id);
    if (old && pageSignature(before, old, content) === pageSignature(after, p, content)) return p;
    changed = true;
    return { ...p, modifiedAt: now.toISOString() };
  });
  return changed ? { ...after, pages } : after;
}
